import React from 'react';

import { useSelector } from 'react-redux';

import { useFeatures } from '@atc/features';

import { AnalyticsEngine } from 'reaxl-analytics';

import globalAnalyticsHandlers from '@/analytics/globalAnalyticsHandlers';
import inventoryAnalyticsHandlers from '@/analytics/inventoryAnalyticsHandlers';
import invPageAnalyticsHandlers from '@/analytics/invPageAnalyticsHandlers';
import ownerAnalyticsHandlers from '@/analytics/ownerAnalyticsHandlers';
import useDataLayer from '@/analytics/useDataLayer';

import birfDuck from '@/ducks/birfDuck.js';
import globalConfigsDuck from '@/ducks/globalConfigsDuck.js';

function InvAnalytics() {
    const {
        thirdparty: [enableThirdParty],
        google_analytics: [, { disableGtm, disableGtmEvents, delay }],
    } = useFeatures([
        'thirdparty',
        'google_analytics',
    ]);

    const dataLayer = useDataLayer();
    const dataIsland = useSelector(birfDuck.selectors.getPageData);
    const telmetricsKey = useSelector(globalConfigsDuck.selectors.getDuckState)?.telmetricsKey;

    const analyticsProps = {
        dataLayer: () => dataLayer,
        instanceId: dataLayer?.page?.pixallPageInstanceId,
        getDataIsland: () => dataIsland,
        google: {
            delay,
        },
        value: {
            ...invPageAnalyticsHandlers,
            ...globalAnalyticsHandlers,
            ...inventoryAnalyticsHandlers,
            ...ownerAnalyticsHandlers,
        },
        option: {
            isOptimizelyEdge: true,
            disableGTM: disableGtm || !enableThirdParty,
            disableGTMEvents: disableGtmEvents,
            disablePixall: !enableThirdParty,
            telmetricsKey,
        },
    };

    return (<AnalyticsEngine {...analyticsProps} />);
}

export default React.memo(InvAnalytics);
